import { Controller } from "@hotwired/stimulus"

const TOOLTIP_IDENTIFIER = "poetry--core--tooltip"

// Poetry tooltips ignore touch. Author upvote needs the same hint on tap.
export default class extends Controller {
  #openedByTouch = false

  open(event) {
    if (event.pointerType !== "touch") return

    event.stopImmediatePropagation()
    this.#openedByTouch = true
    const tooltip = this.#tooltip()
    if (tooltip) tooltip.openValue = true
  }

  keep(event) {
    if (!this.#openedByTouch) return

    event.stopImmediatePropagation()
    this.#openedByTouch = false
  }

  #tooltip() {
    const root =
      this.element.querySelector(`[data-controller*="${TOOLTIP_IDENTIFIER}"]`) ||
      this.element.closest(`[data-controller*="${TOOLTIP_IDENTIFIER}"]`)
    if (!root) return null

    return this.application.getControllerForElementAndIdentifier(root, TOOLTIP_IDENTIFIER)
  }
}
